import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { CoreTranslateService, UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-market-interested',
  templateUrl: './modal-market-interested.component.html',
  styleUrls: ['./modal-market-interested.component.scss']
})
export class ModalMarketInterestedComponent implements OnInit {

  @ViewChild('marketInterestedModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  product: any = {};
  callback: Function;
  interestedModel: any = {};
  errorMsg = '';
  myProfile: any = {};
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
    private utility: UtilitysService,
    private coreTranslate: CoreTranslateService
  ) { }

  async ngOnInit() {
    this.myProfile = await this.utility.getMyProfile();
    this.modalServ.onMarketInterest.subscribe(req => {
      this.errorMsg = '';
      this.product = req.product;
      this.callback = req.callback;
      this.interestedModel = {};
      this.interestedModel.ProductId = this.product.ProductID;
      this.interestedModel.PhoneNumber = this.myProfile.Phone;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketInterestHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm(): void {
    this.interestedProduct();
  }

  interestedProduct() {
    this.ngxLoading.start();
    if (!this.interestedProductValidation()){
      this.ngxLoading.stopAll();
      return;
    } 
    this.api.marketPlaceInterestedProduct(this.interestedModel).subscribe(async(res) => {
      this.ngxLoading.stopAll();
      if (res.Code == 200) {
        this.callback({status: 'success'});
      } else {
        this.callback({status: 'fail', message: res.Message});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, err => {
      console.error(err);
      this.callback({status: 'fail', message: 'Internal Error.'});
      this.hide();
      this.ngxLoading.stopAll();
    });
  }

  interestedProductValidation() {
    if(!this.interestedModel.ProductId) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PRODUCT_NOT_FOUND_PLEASE_TRY_AGAIN');
      return false;
    } else if(!this.interestedModel.hasOwnProperty('PhoneNumber') || !this.interestedModel.PhoneNumber) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PHONE_NUMBER');
      return false;
    }
    return true;
  }

}
